import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

/**
 * @name dna-off
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTUgMmMtMS4zNSAxLjUtMi4wOTIgMy0yLjUgNC41TDE0IDgiIC8+CiAgPHBhdGggZD0ibTE3IDYtMi44OTEtMi44OTEiIC8+CiAgPHBhdGggZD0iTTIgMTVjMy4zMzMtMyA2LjY2Ny0zIDEwLTMiIC8+CiAgPHBhdGggZD0ibTIgMiAyMCAyMCIgLz4KICA8cGF0aCBkPSJtMjAgOSAuODkxLjg5MSIgLz4KICA8cGF0aCBkPSJNMjIgOWMtMS41IDEuMzUtMyAyLjA5Mi00LjUgMi41bC0xLTEiIC8+CiAgPHBhdGggZD0iTTMuMTA5IDE0LjEwOSA0IDE1IiAvPgogIDxwYXRoIGQ9Im02LjUgMTIuNSAxIDEiIC8+CiAgPHBhdGggZD0ibTcgMTggMi44OTEgMi44OTEiIC8+CiAgPHBhdGggZD0iTTkgMjJjMS4zNS0xLjUgMi4wOTItMyAyLjUtNC41TDEwIDE2IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/dna-off
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const DnaOff: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M15 2c-1.35 1.5-2.092 3-2.5 4.5L14 8' }],
    ['path', { d: 'm17 6-2.891-2.891' }],
    ['path', { d: 'M2 15c3.333-3 6.667-3 10-3' }],
    ['path', { d: 'm2 2 20 20' }],
    ['path', { d: 'm20 9 .891.891' }],
    ['path', { d: 'M22 9c-1.5 1.35-3 2.092-4.5 2.5l-1-1' }],
    ['path', { d: 'M3.109 14.109 4 15' }],
    ['path', { d: 'm6.5 12.5 1 1' }],
    ['path', { d: 'm7 18 2.891 2.891' }],
    ['path', { d: 'M9 22c1.35-1.5 2.092-3 2.5-4.5L10 16' }],
  ],
];

export default DnaOff;
